import { render, staticRenderFns } from "./AppFormGroup.vue?vue&type=template&id=0a0c3238"
import script from "./AppFormGroup.vue?vue&type=script&lang=js"
export * from "./AppFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports